import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import ApiUserWithdrawal from "../../../core/api/api.userWithdrawal";
import ApiAccount from "../../../core/api/api.account";
import { useForm, Controller } from "react-hook-form";
import { NumericFormat, PatternFormat } from "react-number-format";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiSupplier from "../../../core/api/api.supplier";

const CreateSupplierWithdrawalModal = ({ showCreateTransactionModal, setShowCreateTransactionModal }) => {
  const [samanehAccounts, setSamanehAccounts] = useState([]);
  const [supplierAccount, setSupplierAccount] = useState([]);
  const [supplierList, setSupplierList] = useState();

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      withdrawalType: "2",
    },
  });

  useEffect(() => {
    const fetchAllApiData = async () => {
      try {
        const response = await ApiAccount.getAllAccountSaamaneh();
        setSamanehAccounts(response);
        // دریافت لیست همه تامین کننده ها
        const suppliersList = await ApiSupplier.getAllSuppliersBalances();
        setSupplierList(suppliersList);
      } catch (error) {
        console.log("error=>", error);
      }
    };
    fetchAllApiData();
  }, []);

  const handleSupplierAccountChange = async (SupplierId) => {
    if (SupplierId)
      try {
        const response = await ApiAccount.getSupplierAccountsWithId({ SupplierId });
        setSupplierAccount(response);
        setValue("destinationAccountId", response);
      } catch (error) {
        console.log("error =>", error);
      }
  };

  const handleClose = () => {
    setShowCreateTransactionModal(false);
  };

  const onSubmit = async (data, e) => {
    data.amount = data.amount ? _.toNumber(data.amount.replace(/,/g, "")) : 0;
    data.supplierId = +data.supplierId?.value;
    data.destinationAccountId = +data.destinationAccountId;
    data.sourceAccountId = +data.sourceAccountId;

    if (data.paymentDate && typeof data.paymentDate === "object") {
      data.paymentDate = tools.DateFormat(data.paymentDate);
    }

    try {
      let response = null;
      response = await ApiUserWithdrawal.createSupplierWithdrawal(data);
      if (response.succeeded == true) document.getElementById("submitButton").click();
      handleClose();
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
      console.log("error=", error);
    }
  };
  const selectedRadio = watch("withdrawalType");
  const selectedSupplier = watch("supplierId");
  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered show={showCreateTransactionModal} onHide={handleClose}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">واریز به حساب بانکی تامین کننده </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Row>
                  <Col>
                    <Controller
                      name="withdrawalType"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <RadioGroup name="withdrawalType" value={value || ""} onChange={onChange} row>
                          <FormControlLabel value="1" control={<Radio />} label="درخواست برداشت وجه" className="mr-4" />
                          <FormControlLabel value="2" control={<Radio />} label="درخواست برداشت وجه و واریز به کارت" />
                        </RadioGroup>
                      )}
                    />
                    {errors.withdrawalType && <span>لطفا نوع درخواست را وارد نمایید</span>}
                  </Col>
                  <Col xs="12" style={{ zIndex: "4" }}>
                    <Controller
                      name="supplierId"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <SelectComponent
                          options={supplierList?.map((item) => ({
                            value: item.id,
                            label: item.companyName,
                            riallBalance: item.riallBalance,
                          }))}
                          placeholder="انتخاب تامین کننده"
                          className="w-100 mt-4"
                          name="supplierId"
                          field={field}
                          onChange={(v) => {
                            field.onChange(v);
                            handleSupplierAccountChange(v?.value);
                          }}
                        />
                      )}
                    />
                    {errors.supplierId && <div class="mt-2 pl-4 text-danger">**لطفا تامین کننده را وارد نمایید</div>}
                  </Col>

                  <Col xs="12">
                    <Controller
                      name="destinationAccountId"
                      control={control}
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          select
                          label="حساب تامین کننده"
                          className="mb-0 "
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                          onChange={onChange}
                        >
                          <MenuItem key={99} value={undefined}>
                            {" "}
                            --{" "}
                          </MenuItem>
                          {supplierAccount?.map((item, index) => (
                            <MenuItem key={index} value={item.id}>
                              {" "}
                              {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                    {errors.destinationAccountId && (
                      <div class="mt-2 pl-4 text-danger">**لطفا حساب تامین کننده را وارد نمایید</div>
                    )}
                  </Col>
                  <Col xs="12" style={{ zIndex: "3" }}>
                    <Row>
                      <Col>
                        <Controller
                          name="amount"
                          control={control}
                          rules={{ required: true }}
                          render={({ field: { onChange, value } }) => (
                            <NumericFormat
                              customInput={TextField}
                              label="مبلغ"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              type="search"
                              value={value || ""}
                              onChange={onChange}
                              thousandSeparator=","
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                            />
                          )}
                        />
                        {errors.amount && <div class="mt-2 pl-4 text-danger">**لطفا مبلغ وارد نمایید</div>}
                      </Col>
                      <Col md="5" className="pe-0">
                        <NumericFormat
                          customInput={TextField}
                          label="موجودی کیف پول تامین کننده"
                          margin="normal"
                          variant="outlined"
                          type="search"
                          size="small"
                          value={selectedSupplier?.riallBalance}
                          thousandSeparator=","
                          disabled
                          suffix="تومان"
                          onKeyDown={(e) => {
                            if (e.key === "Escape") {
                              e.stopPropagation()
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  {selectedRadio === "2" && (
                    <>
                      <Col xs="12">
                        <Controller
                          name="sourceAccountId"
                          control={control}
                          // rules={{ required: true }}
                          rules={{
                            validate: (value) => {
                              const withdrawalType = getValues("withdrawalType");
                              if (withdrawalType === "2" && !value) {
                                return "**لطفا حساب سامانه را وارد نمایید";
                              }
                              return true;
                            },
                          }}
                          render={({ field: { onChange, value } }) => (
                            <TextField
                              select
                              label="انتخاب حساب داخلی"
                              className="my-2"
                              variant="outlined"
                              margin="normal"
                              size="small"
                              value={value || ""}
                              onInput={onChange}
                              onChange={onChange}
                            >
                              <MenuItem key={99} value={undefined}>
                                {" "}
                                --{" "}
                              </MenuItem>
                              {samanehAccounts?.data?.map((item, index) => (
                                <MenuItem key={index} value={item.id}>
                                  {" "}
                                  {item.accountOwnerName + "-- " + item.bank + "-- " + item.accountNumber}{" "}
                                </MenuItem>
                              ))}
                            </TextField>
                          )}
                        />
                        {errors.sourceAccountId && (
                          <div class="mt-2 pl-4 text-danger">{errors.sourceAccountId.message}</div>
                        )}
                      </Col>
                      <Col xs="12">
                        <Controller
                          name="paymentDate"
                          control={control}
                          //rules={{ required: true }}
                          rules={{
                            validate: (value) => {
                              const withdrawalType = getValues("withdrawalType");
                              if (withdrawalType === "2" && !value) {
                                return "**لطفا تاریح تراکنش را وارد نمایید";
                              }
                              return true;
                            },
                          }}
                          render={({ field: { onChange, value } }) => (
                            <ShamsiDatePicker
                              value={value}
                              onChange={onChange}
                              placeholder="تاریخ پرداخت"
                              className="mt-2"
                            />
                          )}
                        />
                        {errors.paymentDate && <div class="mt-2 pl-4 text-danger">{errors.paymentDate.message}</div>}
                      </Col>
                      <Col xs="12">
                        <Controller
                          name="paymentTime"
                          control={control}
                          //rules={{ required: true }}
                          rules={{
                            validate: (value) => {
                              const withdrawalType = getValues("withdrawalType");
                              if (withdrawalType === "2" && !value) {
                                return "**لطفا ساعت تراکنش را وارد نمایید";
                              }
                              return true;
                            },
                          }}
                          render={({ field: { onChange, value } }) => (
                            <PatternFormat
                              customInput={TextField}
                              type="search"
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                              label="ساعت پرداخت"
                              size="small"
                              margin="normal"
                              value={value || ""}
                              variant="outlined"
                              onChange={onChange}
                              placeholder="00:00"
                              format="##:##"
                              allowEmptyFormatting={false}
                              className="mt-4"
                            />
                          )}
                        />
                        {errors.paymentTime && <div class=" pl-4 text-danger">{errors.paymentTime.message}</div>}
                      </Col>
                      <Col xs="12">
                        <Controller
                          name="trackingCode"
                          control={control}
                          // rules={{ required: true }}
                          // rules={{
                          //   validate: (value) => {
                          //     const withdrawalType = getValues("withdrawalType");
                          //     if (withdrawalType === "2" && !value) {
                          //       return "**لطفا کد رهگیری را وارد نمایید";
                          //     }
                          //     return true;
                          //   },
                          // }}
                          render={({ field: { onChange, value } }) => (
                            <NumericFormat
                              customInput={TextField}
                              label="کد رهگیری"
                              margin="normal"
                              variant="outlined"
                              size="small"
                              type="search"
                              value={value || ""}
                              onChange={onChange}
                              className="mt-2 mb-2"
                              onKeyDown={(e) => {
                                if (e.key === "Escape") {
                                  e.stopPropagation()
                                }
                              }}
                            />
                          )}
                        />
                        {/* {errors.trackingCode && <div class="mt-2 pl-4 text-danger">{errors.trackingCode.message}</div>} */}
                      </Col>
                    </>
                  )}
                  <Col xs="12">
                    <Controller
                      name="description"
                      control={control}
                      rules={{ required: false }}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="توضیحات"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                          className="mt-2"
                        />
                      )}
                    />
                    {errors.description && (
                      <div class="mt-2 pl-4 text-danger">**لطفا ساعت اتمام فروش را وارد نمایید</div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default CreateSupplierWithdrawalModal;
